module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/plan/plan-387-327b4634178380f59c077326a46a6e3b.jpg";